import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X, Phone } from 'lucide-react';

const Header = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

    const navLinks = [
        { name: 'Home', href: '/' },
        { name: 'Services', href: '/services' },

        { name: 'About', href: '/about' },
        { name: 'Gallery', href: '/gallery' },
        { name: 'Contact', href: '/contact' },
    ];

    return (
        <header className="sticky top-0 z-50 bg-white shadow-md">
            <div className="container mx-auto px-4 py-3 flex justify-between items-center">
                {/* Logo */}
                <Link to="/" className="flex items-center group">
                    <div className="relative">
                        <img src="/assets/logo/jclogo.png" alt="Joshi Construction" className="h-10 md:h-12 w-auto mr-2" />
                        <span className="absolute -top-1 -right-0 text-[10px] text-gray-800 font-bold bg-white rounded-full leading-none px-[1px]">®</span>
                    </div>
                    <span className="text-xl font-bold text-gray-800">Joshi Construction</span>
                </Link>



                {/* Desktop Navigation */}
                <nav className="hidden md:flex space-x-8 items-center">
                    {navLinks.map((link) => (
                        <Link
                            key={link.name}
                            to={link.href}
                            className="text-gray-600 hover:text-primary font-medium transition-colors duration-300"
                        >
                            {link.name}
                        </Link>
                    ))}
                    <a
                        href="tel:+919098027286"
                        className="flex items-center bg-primary text-white px-4 py-2 rounded-md hover:bg-orange-700 transition-colors duration-300 font-semibold"
                    >
                        <Phone size={18} className="mr-2" />
                        Call Now
                    </a>
                </nav>

                {/* Mobile Menu Button */}
                <div className="md:hidden">
                    <button
                        onClick={toggleMenu}
                        className="text-gray-600 hover:text-primary focus:outline-none"
                    >
                        {isMenuOpen ? <X size={28} /> : <Menu size={28} />}
                    </button>
                </div>
            </div>

            {/* Mobile Navigation Drawer */}
            {isMenuOpen && (
                <div className="md:hidden bg-white border-t border-gray-100 absolute w-full shadow-lg">
                    <div className="flex flex-col px-4 py-4 space-y-4">
                        {navLinks.map((link) => (
                            <Link
                                key={link.name}
                                to={link.href}
                                className="text-gray-700 hover:text-primary font-medium text-lg border-b border-gray-50 pb-2"
                                onClick={toggleMenu}
                            >
                                {link.name}
                            </Link>
                        ))}
                        <a
                            href="tel:+919098027286"
                            className="flex justify-center items-center bg-primary text-white px-4 py-3 rounded-md hover:bg-orange-700 transition-colors duration-300 font-semibold mt-2"
                            onClick={toggleMenu}
                        >
                            <Phone size={20} className="mr-2" />
                            Call Now
                        </a>
                    </div>
                </div>
            )}
        </header>
    );
};

export default Header;
